import { Behavior } from './Behavior';
import { ContentType, LessonMode, QuestionFeedbackState } from '../../Constants';
import scoringService from '../services/ScoringService';
import utilsService from '../services/UtilsService';
import questionFeedbackManager from '../managers/QuestionFeedbackManager';

export class OrderSentencesBehavior extends Behavior {
  checkForValidResponse = (responseAnswer) => {
    return (responseAnswer.prompts.length > 0);
  }

  setCorrectAnswer = (state, model) => {
    const promptObjects = [];
    for (const rPrompt of model.validation?.prompts) {
      for (const mPrompt of model.prompts) {
        if (rPrompt === mPrompt.id) {
          const orderPrompt = {
            id: mPrompt.id,
            text: mPrompt.text
          };
          promptObjects.push(orderPrompt);
        }
      }
    }
    const prompts = promptObjects.map((p) => p.id);
    const responseAnswer = {
      promptObjects,
      prompts,
      lessonElementId: model.lessonElementId
    };

    state.setCurrentResponse(responseAnswer);
  }

  resetStudentAnswer = (state) => {
    state.setCurrentResponse(utilsService.safeMobxClone(state.cachedResponseAnswer));
  }

  setResponseData = (data, responseAnswer, model) => {
    responseAnswer.promptObjects = data;
    const prompts = data.map((p) => p.id);
    responseAnswer.prompts = prompts;
  }

  getInitializedResponse = (lessonElementId, model) => {
    const promptObjects = [];

    model.prompts.forEach((prompt, index) => {
      const newPrompt = {
        id: prompt.id,
        text: prompt.text
      };
      promptObjects.push(newPrompt);
    });

    // const prompts = promptObjects.map(p => p.id);
    const responseAnswer = {
      promptObjects,
      prompts: [],
      lessonElementId
    };
    return responseAnswer;
  }

  isAutoScored = (model) => {
    const auto = (ContentType.getAutoscore(model.type) &&
      !model.survey && !model.unscored);
    return auto;
  }

  getAnswerFeedback = (id, responseAnswer) => {
    throw new Error('Behavior.getAnswerFeedback must be implemented');
  }

  getCorrectAnswersText = (model) => {
    // Removed because accepted answers is not needed for this question type (CF-3749).
    // // Finds the correct answer id,
    // // finds the answer text for that id, and returns that text
    // if (model?.validation?.answers?.length > 0) {
    //   const correctAnswer = model.validation.answers.find(({ isCorrect }) => isCorrect);
    //   const correctAnswerText = model.answers.find(({ id }) => id === correctAnswer.id).text;
    //   return `<div>${correctAnswerText}</div>`;
    // }
    // return '<div></div>';
    return '';
  }

  getQuestionFeedbackText = (model, correctFeedback, incorrectFeedback, correctFeedbackBody, incorrectFeedbackBody, mode, questionIsCorrect, currentAttemptCount, { lessonElementState }) => {
    let textBody = '';
    if (mode === LessonMode.PREVIEW || mode === LessonMode.ITEM_PREVIEW || mode === LessonMode.STUDENT_PREVIEW || mode === LessonMode.PUBLISHER_PREVIEW) {
      textBody += utilsService.previewWarning();
    } else {
      if (typeof currentAttemptCount !== 'undefined' && currentAttemptCount !== -1 && currentAttemptCount > 1) {
        textBody += utilsService.saveWarning();
      } else {
        textBody += utilsService.saveCommit();
      }
    }

    let textHeader = '';
    let attemptsText = '';
    
    // Add attempts remaining text for practice mode when answer is incorrect or partially correct
    if (questionFeedbackManager.isPractice && 
        (questionIsCorrect === QuestionFeedbackState.INCORRECT || questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) &&
        model.lessonElementId) {
      attemptsText = questionFeedbackManager.getAttemptsRemainingText(model.lessonElementId);
    }

    if (questionIsCorrect === QuestionFeedbackState.CORRECT) {
      textHeader = correctFeedback;
      if (correctFeedbackBody) {
        textBody = `${correctFeedbackBody} ${textBody}`;
      }
    } else if (questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) {
      textHeader = `${utilsService.partiallyCorrect()}`;
      let custom = '';
      if (incorrectFeedbackBody) {
        custom = `${incorrectFeedbackBody } `;
      }
      textBody = `${utilsService.partiallyCorrectPrompt()}. <br/>${ custom }${textBody}`;
    } else {
      textHeader = incorrectFeedback;
      if (incorrectFeedbackBody) {
        textBody = `${incorrectFeedbackBody} ${textBody}`;
      }
    }

    // Add attempts text after the header if it exists
    if (attemptsText) {
      textHeader += attemptsText;
    }

    let finalText = '<div class=\'question-feedback-header\'>';
    finalText += textHeader;
    finalText += '</div>';
    finalText += '<div class=\'question-feedback-body\'>';
    finalText += textBody;
    finalText += '</div>';

    return finalText;
  }

  isAnswerCorrect = (answerId, lessonElementState, model) => {
    // NA for this type.
    return null;
  }

  isQuestionCorrect = (lessonElementState, lessonElementId) => {
    if (!lessonElementState) {
      return QuestionFeedbackState.INCORRECT;
    }

    if (lessonElementState.submittedItemScore >= lessonElementState.maxScore) {
      return QuestionFeedbackState.CORRECT;
    }
    if ((lessonElementState.submittedItemScore > 0) && (lessonElementState.submittedItemScore < lessonElementState.maxScore)) {
      return QuestionFeedbackState.PARTIAL_CORRECT;
    }

    return QuestionFeedbackState.INCORRECT;
  }
}

export default new OrderSentencesBehavior();
